const getFilenameFromUrl = url => {
  try {
    const parsed = new URL(url)
    const pathname = parsed.pathname || ''
    const filename = pathname.split('/').pop()
    return filename || 'arquivo'
  } catch (error) {
    return 'arquivo'
  }
}

const normalizeFilename = filename => {
  if (!filename || typeof filename !== 'string') {
    return null
  }

  const cleaned = filename.trim().replace(/[\\/:*?"<>|]/g, '_')
  return cleaned || null
}

export const downloadFileFromUrl = async (url, preferredFilename) => {
  if (!url) return

  const fallbackFilename =
    normalizeFilename(preferredFilename) || getFilenameFromUrl(url)

  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include'
    })

    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`)
    }

    const blob = await response.blob()
    const objectUrl = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fallbackFilename
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.URL.revokeObjectURL(objectUrl)
    return
  } catch (error) {
    const link = document.createElement('a')
    link.href = url
    link.download = fallbackFilename
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
